import { render } from "./AuraChat.vue?vue&type=template&id=4f28391c&ts=true"
import script from "./AuraChat.vue?vue&type=script&setup=true&lang=ts"
export * from "./AuraChat.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/pages/aura/AuraChat.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4f28391c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4f28391c', __exports__)) {
    api.reload('4f28391c', __exports__)
  }
  
  module.hot.accept("./AuraChat.vue?vue&type=template&id=4f28391c&ts=true", () => {
    api.rerender('4f28391c', render)
  })

}


export default __exports__